<template>
    <v-app id="us-v-app">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goBack">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;width:95%;padding-left:0.4rem;">
              <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">
                企业信息
              </span>
            </v-toolbar-title>
        </v-app-bar>
        <v-content style="background:#f2f2f2;padding-bottom:2rem;">
            <v-container style="padding-top:0.7rem;">
              <div v-if="loading" style="margin-top:10rem;">
                <LoadingText />
              </div>
              <div v-else>
                <v-card flat>
                  <div style="text-align:center;padding:0.5rem 1.5rem;padding-top:1.2rem;">{{companyInfo.COMPANY_NAME}}</div>
                  <v-list subheader two-line>
                    <v-subheader style="height:2rem;padding-bottom:0.55rem;">设置</v-subheader>
                    <v-list-item style="min-height:55px;max-height:55px;padding-right:0.15rem;position: relative;">
                        <v-list-item-content>
                            <v-list-item-title style="font-size:0.9rem;">接收消息推送</v-list-item-title>
                            <v-list-item-subtitle style="font-size:0.7rem;margin-top:0.2rem;padding-right:1.9rem;color:#9e9e9e;">新工单通知、设备异常/恢复通知</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-icon>
                          <v-switch v-model="settInfo.rps" style="position: absolute;top: -0.65rem;right: 1rem;" color="info" @change="setRecvPushSid" />
                        </v-list-item-icon>
                    </v-list-item>
                    <v-list-item style="min-height:2.6rem;max-height:3rem;padding-right:0.15rem;" @click="goStaffMgr">
                      <v-list-item-content style="padding:0.55rem 0;">
                        <v-list-item-title style="font-size:0.9rem;padding-top:0.1rem;">管理成员</v-list-item-title>
                        <v-list-item-subtitle style="font-size:0.7rem;margin-top:0.15rem;padding-right:1.9rem;color:#9e9e9e;">移除成员</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-icon style="margin:0;margin-left:1rem;">
                        <v-icon color="grey" style="margin-top:0.665rem;">fa fa-angle-right</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                    <v-list-item style="min-height:2.6rem;max-height:3rem;padding-right:0.15rem;" @click="goInvite">
                      <v-list-item-content style="padding:0.55rem 0;">
                        <v-list-item-title style="font-size:0.9rem;padding-top:0.1rem;">邀请新成员</v-list-item-title>
                        <v-list-item-subtitle style="font-size:0.7rem;margin-top:0.15rem;padding-right:1.9rem;color:#9e9e9e;">分享邀请码</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-icon style="margin:0;margin-left:1rem;">
                        <v-icon color="grey" style="margin-top:0.665rem;">fa fa-angle-right</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                    <v-list-item style="min-height:2.6rem;max-height:3rem;padding-right:0.15rem;" @click="goTransfer">
                      <v-list-item-content style="padding:0.55rem 0;">
                        <v-list-item-title style="font-size:0.9rem;padding-top:0.1rem;">转让企业管理权</v-list-item-title>
                        <v-list-item-subtitle style="font-size:0.7rem;margin-top:0.15rem;padding-right:1.9rem;color:#9e9e9e;">分享转让</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-icon style="margin:0;margin-left:1rem;">
                        <v-icon color="grey" style="margin-top:0.665rem;">fa fa-angle-right</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                    <v-list-item style="min-height:2.6rem;max-height:3rem;padding-right:0.15rem;" @click="goMoreOp">
                      <v-list-item-content style="padding:0.55rem 0;">
                        <v-list-item-title style="font-size:0.9rem;padding-top:0.1rem;">更多</v-list-item-title>
                        <v-list-item-subtitle style="font-size:0.7rem;margin-top:0.15rem;padding-right:1.9rem;color:#9e9e9e;">查看日志、修改企业名称、退出企业</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-icon style="margin:0;margin-left:1rem;">
                        <v-icon color="grey" style="margin-top:0.665rem;">fa fa-angle-right</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-list>
                </v-card>
                <v-divider style="border-color:#f2f2f2;"></v-divider>
                <v-list subheader>
                  <v-subheader>管理员</v-subheader>
                  <v-list-item v-for="item in adminList" :key="item.GZ_COMPANY_STAFF_ID">
                      <v-list-item-avatar style="border-radius:0.3rem;">
                        <v-img v-if="item.STAFF_HEAD_URL!==''" :src="item.STAFF_HEAD_URL"></v-img>
                        <v-icon  v-else style="font-size:2rem;color:#9E9E9E;">mdi-account-circle</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <div v-if="item.STAFF_NAME!==''">{{item.STAFF_NAME}}</div>
                          <div v-else>{{item.STAFF_ALIAS}}</div>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon>
                      </v-list-item-icon>
                  </v-list-item>
                </v-list>
                <v-divider style="border-color:#f2f2f2;"></v-divider>
                <v-list subheader v-if="showCommon">
                  <v-subheader>其它成员({{otherList.length}})</v-subheader>
                  <v-list-item v-for="item in otherList" :key="item.GZ_COMPANY_STAFF_ID">
                      <v-list-item-avatar style="border-radius:0.3rem;">
                        <v-img v-if="item.STAFF_HEAD_URL!==''" :src="item.STAFF_HEAD_URL"></v-img>
                        <v-icon  v-else style="font-size:2.75rem;color:#9E9E9E;">mdi-account-circle</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <div v-if="item.STAFF_NAME!==''">{{item.STAFF_NAME}}</div>
                          <div v-else>{{item.STAFF_ALIAS}}</div>
                          <div style="font-size:0.7rem;padding-top:0.2rem;color:#9e9e9e;">加入时间：{{$moment(item.JOIN_DATE).format('YYYY-MM-DD HH:mm')}}</div>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon>
                      </v-list-item-icon>
                  </v-list-item>
                  <div v-if="otherList.length === 0" style="text-align:center;color:#9e9e9e;font-size:0.8rem;margin-top:1rem;margin-bottom:2.5rem;">
                      暂无成员
                  </div>
                </v-list>
              </div>
            </v-container>
            <ShareQrCode ref="shareQrCode" title="邀请码" :visible.sync="shareVis" />
        </v-content>
    </v-app>
</template>

<script>
import ShareQrCode from '../../components/ShareQrCode'
import LoadingText from '../../components/LoadingText'
export default {
  components: {
    ShareQrCode,
    LoadingText
  },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: [],
      adminList: [],
      otherList: [],
      shareVis: false,
      // 分享有效期(分钟)
      shareExpiry: 30,
      showCommon: false,
      companyCode: '',
      companyInfo: {},
      settInfo: {
        rps: false
      },
      loading: true,
      userInfo: {},
      role: 'common'
    }
  },
  computed: {
  },
  mounted() {
    // var that = this
    // that.init()
  },
  created() {
  },
  activated() {
    var that = this
    if (!that.$router.isBack) {
      that.init()
    } else {
      that.getStaffList()
      that.getCompanyInfo()
    }
  },
  methods: {
    goBack() {
      var that = this;
      that.$router.goBack()
    },
    async init() {
      var that = this
      that.loading = true
      that.userInfo = that.$AppHelper.getCustomData('user_info');
      var staffInfo = that.$AppHelper.getCustomData('staff_info');
      that.companyCode = staffInfo.COMPANY_CODE;
      if (staffInfo && staffInfo.STAFF_ROLE === 'admin') {
        that.showCommon = true
      }
      var code = that.$route.query.code
      if (code) {
        that.companyCode = code
        that.showCommon = true
      }
      await that.getCompanyInfo()
      await that.getStaffList()
      await that.getUserSetting()
      that.loading = false
    },
    // 获取员工列表
    async getStaffList() {
      var that = this;
      if (!that.companyCode) {
        return
      }
      var res = await that.$api.bz.getStaffList({ code: that.companyCode })
      // console.log('getStaffList.res', res);
      if (!res.success) {
        // that.$toast.warning('获取员工列表失败');
        console.log('获取成员列表失败', res);
        return
      }
      that.list = res.data
      that.adminList = []
      that.otherList = []
      for (let index = 0; index < that.list.length; index++) {
        var item = that.list[index];
        if (item.STAFF_ROLE === 'admin') {
          that.adminList.push(item)
          continue;
        }
        that.otherList.push(item)
      }
    },
    // 邀请新成员弹出邀请二维码
    inviteStaff(role) {
      var that = this;
      if (!that.companyCode) {
        return
      }
      if (!that.hasPermission()) {
        return
      }
      that.$api.bz.createCompanyInvite({ company_code: that.companyCode, invite_expiry: that.shareExpiry, s_role: role }).then(res => {
        // console.log('生成公司邀请码', res)
        if (!res.success) {
          that.$toast.warning('生成邀请码失败')
          console.log('生成企业邀请码失败', res)
          return
        }
        var data = res.data
        that.$refs.shareQrCode.setQrContent(data)
        that.shareVis = !that.shareVis
      })
    },
    // 获取企业信息
    async getCompanyInfo() {
      var that = this
      if (!that.companyCode) {
        return;
      }
      var res = await that.$api.bz.getCompanyInfo({ code: that.companyCode })
      // console.log('getCompanyInfo.res', res);
      if (!res.success) {
        // that.$toast.warning('获取企业信息失败');
        console.log('获取企业信息失败', res)
        return
      }
      that.companyInfo = res.data
    },
    // 获取用户设置
    async getUserSetting() {
      var that = this
      var res = await that.$api.bz.getUserSetting({ company_code: that.companyCode })
      if (!res.success) {
        console.log('获取用户设置失败', res);
        return;
      }
      var data = res.data
      that.settInfo.rps = data.recv_push_sid === 2
      that.loading = false
    },
    // 消息推送设置
    async setRecvPushSid() {
      var that = this
      // console.log('recv_push_sid', that.settInfo.rps);
      var res = await that.$api.bz.setRecvPushSid({ company_code: that.companyCode, rps: that.settInfo.rps ? 2 : 0 })
      // console.log('setRecvPushSid.res', res);
      if (!res.success) {
        that.$toast.warning('设置失败')
        return
      }
      that.$toast.success('设置成功')
    },
    // 是否管理员权限
    hasPermission() {
      var that = this
      if (that.companyInfo.COMPANY_ADMIN_CODE !== that.userInfo.usercode) {
        that.$toast.warning('只有管理员才可以操作');
        return false
      }
      return true
    },
    goStaffMgr() {
      var that = this
      if (!that.hasPermission()) {
        return
      }
      that.$router.goPage({ path: '/EntStaffManage', query: { code: that.companyCode }})
    },
    async goInvite() {
      var that = this
      if (!that.hasPermission()) {
        return
      }
      var res = await that.$api.bz.createCompanyInvite({ company_code: that.companyInfo.COMPANY_CODE, invite_expiry: that.shareExpiry, s_role: that.role })
      // console.log('生成企业邀请码', res)
      if (!res.success) {
        // that.$toast.error('生成企业邀请码失败')
        console.log('生成企业邀请码失败', res);
        that.$toast.warning('生成邀请二维码失败');
        return
      }
      var data = res.data
      var query = { code: that.companyInfo.COMPANY_CODE, name: that.companyInfo.COMPANY_NAME, qrcode: data, expiry: that.shareExpiry }
      that.$router.goPage({ path: '/EntInvite', query: query })
    },
    async goTransfer() {
      var that = this
      if (!that.hasPermission()) {
        return
      }
      if (that.companyInfo.IS_OWNER) {
        that.$toast.warning('不允许转让');
        return
      }
      var res = await that.$api.bz.tranferCompany({ company_code: that.companyInfo.COMPANY_CODE, invite_expiry: that.shareExpiry })
      // console.log('生成企业邀请码', res)
      if (!res.success) {
        // that.$toast.error('转让企业失败1')
        console.log('转让企业失败', res);
        return
      }
      var data = res.data
      var query = { code: that.companyInfo.COMPANY_CODE, name: that.companyInfo.COMPANY_NAME, qrcode: data, expiry: that.shareExpiry }
      that.$router.goPage({ path: '/EntTransfer', query: query })
    },
    // 更多
    goMoreOp() {
      var that = this
      that.$router.goPage({ path: '/EntMoreOp', query: { code: that.companyCode }})
    }
  }
}
</script>

<style scoped>
</style>
